import { getApiUrl } from '../../Url';

export type PodcastEpisodeListParameters = { limit: number; page: number };

export type Episode = {
  episodeId: string;
  title: string | null;
  publishOn: string | null;
  created: string;
  createdUnixTimestamp: number;
  totalPlays: number;
  duration: number;
  adCount: number;
  shareLinkPath: string;
  shareLinkEmbedPath: string;
  downloadUrl: string;
};

export type PodcastEpisodeListResponse = {
  episodes: Episode[];
  limit: number;
  page: number;
};

export async function fetchPodcastEpisodeList(
  parameters: PodcastEpisodeListParameters
): Promise<PodcastEpisodeListResponse> {
  try {
    const { limit, page } = parameters;
    const response = await fetch(
      getApiUrl({
        path: `podcastepisodelist`,
        queryParameters: {
          limit,
          page,
        },
        isWebEndpoint: true,
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (response.ok) {
      return await response.json();
    }
    throw new Error('Unable to fetch current user podcast episode list');
  } catch (err) {
    throw new Error(err.message);
  }
}
